import getCurrentReduxSelector from 'modules/redux/selectors/get-current'
import { EXERCISES_DOMAIN, EXERCISES_KEY, EXERCISES_PATH, getQueryExercisesSelect } from '@gymaholic/packages'
import isLoadingReduxUtil from 'modules/redux/utils/is-loading'
import isLoadedReduxUtil from 'modules/redux/utils/is-loaded'

export const getCurrentExerciseSelect = getCurrentReduxSelector(
  EXERCISES_PATH.DATA,
  EXERCISES_PATH.CURRENT
)

export const getCreatedExercisesSelector = () => {
  return (state) => {
    if (state[EXERCISES_DOMAIN].created !== undefined) {
      return state[EXERCISES_DOMAIN].created
    }
  }
}

export const isExercisesLoadingSelector = () => {
  return (state) => {
    return isLoadingReduxUtil(state[EXERCISES_DOMAIN][EXERCISES_KEY.ALL])
  }
}

export const isExercisesLoadedSelector = () => {
  return (state) => {
    return isLoadedReduxUtil(state[EXERCISES_DOMAIN][EXERCISES_KEY.ALL])
  }
}

export const isQueryExercisesLoadingSelector = () => {
  return (state) => {
    const query = getQueryExercisesSelect(state)
    if (state[EXERCISES_DOMAIN].byQuery !== undefined) {
      if (state[EXERCISES_DOMAIN].byQuery[query] !== undefined) {
        return isLoadingReduxUtil(state[EXERCISES_DOMAIN].byQuery[query])
      }
    }
  }
}

export const isExerciseLoadingByIdSelector = (id) => {
  return (state) => {
    if (state[EXERCISES_DOMAIN].data[id] !== undefined) {
      return isLoadingReduxUtil(state[EXERCISES_DOMAIN].data[id])
    }
  }
}
